export type Listener<T> = (state: Readonly<T>) => void;

export interface Store<T extends object> {
  readonly state: T;
  subscribe(listener: Listener<T>): () => void;
}

export function createStore<T extends object>(initial: T): Store<T> {
  const listeners = new Set<Listener<T>>();

  const state = new Proxy(initial, {
    set(target, key, value, receiver): boolean {
      if (Reflect.get(target, key, receiver) === value) {
        return true;
      }
      if (!Reflect.set(target, key, value, receiver)) {
        return false;
      }
      for (const listener of listeners) {
        listener(state);
      }
      return true;
    },
  });

  return {
    state,
    subscribe(listener: Listener<T>): () => void {
      listeners.add(listener);
      return () => {
        listeners.delete(listener);
      };
    },
  };
}
